import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    rejectLoader: false,
    rejectDetails: '',
    rejectError: '',
    taxTypeLoader: false,
    taxType: '',
    taxTypeError: '',
    workflowLoader: false,
    workflowDetails: '',
    workflowError: '',
    frequencyLoader: false,
    frequencyDetails: '',
    frequencyError: ''
};

export default function younoteAdminSetupReducer(state = initState, action) {
    switch (action.type) {
        case actions.REJECT_DETAILS_START: {
            return {
                ...state,
                rejectLoader: true,
            };
        }
        case actions.REJECT_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                rejectLoader: false,
                rejectDetails: action.payload,
            };
        }
        case actions.REJECT_DETAILS_FAILURE: {
            return {
                ...state,
                rejectLoader: false,
                rejectError: action.message,
            };
        }
        case actions.TAX_TYPE_START: {
            return {
                ...state,
                taxTypeLoader: true,
            };
        }
        case actions.TAX_TYPE_SUCCESS: {
            return {
                ...state,
                taxTypeLoader: false,
                taxType: action.payload,
            };
        }
        case actions.TAX_TYPE_FAILURE: {
            return {
                ...state,
                taxTypeLoader: false,
                taxTypeError: action.message,
            };
        }
        case actions.WORKFLOW_START: {
            return {
                ...state,
                workflowLoader: true,
            };
        }
        case actions.WORKFLOW_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                workflowLoader: false,
                workflowDetails: action.payload,
            };
        }
        case actions.WORKFLOW_FAILURE: {
            return {
                ...state,
                workflowLoader: false,
                workflowError: action.message,
            };
        }
        case actions.FREQUENCY_START: {
            return {
                ...state,
                frequencyLoader: true,
            };
        }
        case actions.FREQUENCY_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                frequencyLoader: false,
                frequencyDetails: action.payload,
            };
        }
        case actions.FREQUENCY_FAILURE: {
            return {
                ...state,
                frequencyLoader: false,
                frequencyError: action.message,
            };
        }
        case actions.CLEAR_SETUP_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_SETUP_SUCCESS: {
            return initState;
        }
        default:
            return state;
    }
}